export async function getHealth({ signal } = {}) {
  const response = await fetch('/api/health', { signal });
  if (!response.ok) throw new Error(`Health check failed (${response.status})`);
  return response.json();
}

export async function getGlassCeiling({ signal } = {}) {
  const response = await fetch('/api/indicators/glass-ceiling', { signal });
  if (!response.ok) throw new Error(`Glass Ceiling request failed (${response.status})`);
  return response.json();
}

export async function getProgrammingPayGap({ signal } = {}) {
  const response = await fetch('/api/indicators/programming-pay-gap', { signal });
  if (!response.ok) throw new Error(`Programming Pay Gap request failed (${response.status})`);
  return response.json();
}

export async function getDiasporaReach({ signal } = {}) {
  const response = await fetch('/api/indicators/diaspora-reach', { signal });
  if (!response.ok) throw new Error(`Diaspora Reach request failed (${response.status})`);
  return response.json();
}
